export const COMPLETED_QUEUES = [1];

export const isCompletedQueue = queue => COMPLETED_QUEUES.includes(queue);
